import { KennektTabs } from './KennektTabs';
import { KennektTab } from './KennektTab';

export default {
	Tabs: KennektTabs,
	Tab: KennektTab
};
